import React, { useEffect, useState } from "react";
import { MdOutlineTextsms } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";
import CountdownLoader from "./TimerWithLoader";
import ALoader from "views/pages/manage/common/a-loader";
import { maskEmail, maskPhoneNumber } from "./utils";

const containerStyle = {
  border: "1px solid #E2E2E2",
  padding: "10px 12px",
  borderRadius: "8px",
  fontSize: "14px",
  flex: 1,
};
const activeBorder = {
  border: "1px solid #0f0f0f",
};
const mediumTypeList = ["email", "mobile", "whatsapp"];

const getNotificationsMedium = (studentContactDetails, studentName) => {
  return mediumTypeList?.map((item) => {
    if (item === "mobile" && studentContactDetails?.mobile) {
      
      return {
        icon: <MdOutlineTextsms size={24} />,
        value:`${studentName} (${maskPhoneNumber(studentContactDetails?.mobile)})`,
        type: "SMS",
        key: "mobile",
        mobile: studentContactDetails?.mobile,
      };
    } else if (item === "email" && studentContactDetails?.email) {
      return {
        icon: <MdOutlineMail size={24} />,
        value: maskEmail(studentContactDetails?.email),
        email: studentContactDetails?.email,
        type: "EMAIL",
        key: "email",
      };
    } else if ((item = "mobile" && studentContactDetails?.mobile)) {
      return {
        icon: <FaWhatsapp size={24} />,
        value: `${studentName} (${maskPhoneNumber(studentContactDetails?.mobile)})`,
        type: "WHATSAPP",
        key: "mobile",
        mobile: studentContactDetails?.mobile,
      };
    } else {
      return null;
    }
  });
};
export const MediumType = ({
  currentMedium,
  setCurrentMedium,
  studentContactDetails,
  studentName
}) => {
  if (!studentContactDetails?.contactDetails) return <ALoader />;
  const notificationList = getNotificationsMedium(
    studentContactDetails?.contactDetails,
    studentName
  ).filter((item) => item?.value?.trim()?.length);

  const notificationMediumHandler = (medium) => {
    if (currentMedium.some((i) => i.type === medium.type)) {
      setCurrentMedium(
        currentMedium.filter((item) => item.type !== medium?.type)
      );
    } else {
      setCurrentMedium([...currentMedium, medium]);
    }
  };
  return (
    <div className="link-container d-flex gap-md flex-fill mt-2">
      {notificationList.map((Item) => (
        <div
          style={{
            ...containerStyle,
            maxWidth: "300px",
            ...(currentMedium?.some((i) => i.type === Item.type)
              ? activeBorder
              : {}),
          }}
          onClick={() => notificationMediumHandler(Item)}
          className="d-flex"
          key={Item.type}
        >
          {Item.icon}
          <div className="ml-2">
            <div className="text-dark text-bold">{Item.type}</div>
            <span style={{ fontSize: "12px" }}>{Item.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
